<template>
  <div class="base-layout">
    <junket-header/>
    <junket-nav/>
    <junket-main/>
    <junket-footer/>
  </div>
</template>

<script>
  // @ is an alias to /src
  import JunketHeader from '@/components/layout/JunketHeader.vue'
  import JunketNav from '@/components/layout/JunketNav.vue'
  import JunketMain from '@/components/layout/JunketMain.vue'
  import JunketFooter from '@/components/layout/JunketFooter.vue'
  export default {
    name: 'base-layout',
    components: {
      JunketHeader,
      JunketNav,
      JunketMain,
      JunketFooter
    }
  }
</script>
